<template>
    <section class="module-small bg-dark ctaImg">
          <div class="container" style="width:-webkit-fill-available;">
            <div class="row">
              <div class="col-xs-12">
                <div>
                  <SendyInline/>
                  <!-- <h3 class="cta-title">Suscribe to our newsletter!</h3> -->
                 <!-- <h3 class="cta-title">Wishlist on Steam today!</h3> 
                 <a href="https://store.steampowered.com/app/1132760/Dwerve/"  rel="noopener noreferrer" target="_blank">
                    <div class="steam-btn hvr-grow-shadow"><img src="static/assets/images/steam-icon-19.png" alt="dwerve-steam"/> <span>Wishlist on Steam</span></div>
                 </a> -->
                  <!-- <v-popover
                    offset="6"
                    :autoHide="hide"
                    :disabled="!isEnabled"
                  > -->
                    <!-- <a @click="whyWishlist(), e => e.target.classList.toggle('active')" class="tooltip-target b3">Why should I Wishlist Dwerve?</a> -->
                    <!-- <a v-on:click="makeActive" v-bind:class="{active: isActive}" class="tooltip-target b3">Why should I Wishlist Dwerve?</a> -->
                    <!-- <template slot="popover">
                      <p>
                          Did you know over 9,300 games launched in 2018 alone? That's about 25 games a day!
                          It's hard to stand out from the crowd, even when you have a good game. 😟
                          Luckily, getting featured on launch day can get a game a lot of exposure!
                          Will you help us get featured by <a href="https://store.steampowered.com/app/1132760/Dwerve/" target="_blank">wishlisting</a> Dwerve on Steam?
                      </p>

                    </template> -->
                  <!-- </v-popover> -->
                
                </div>
              </div>
            </div>
          </div>
        </section>
</template>

<script>
import SendyInline from "@/views/Home/SendyInline.vue";
import FollowModal from "@/views/Home/FollowModal.vue";
import VTooltip from 'v-tooltip';
import KickstarterCTA from "@/views/Home/KickstarterCTA.vue";

export default {
  data() {
    return {
      msg: "hey",
      isEnabled: true,
      hide: false,
      isActive: false,
    };
  },
  components: {
    FollowModal,
    SendyInline
  },
  methods: {
    makeActive(){
      this.isActive = !this.isActive;
      $('.popover').addClass('test3');
    }
  }
};
</script>

<style scoped>
@media all and (orientation:landscape) and (max-width: 900px) {
}
.container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tooltip.info .tooltip-inner {
  background: rgba(0, 68, 153, .9);
  color: white;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
  max-width: 250px;
  display: block !important;
}
.tooltip.info .tooltip-arrow {
  display: block !important;
  border-color: rgba(0, 68, 153, .9);
}

.row {
    width: 100%;
}
.v-popover a.tooltip-target {
    font-size: 15px;
    font-family: "Open Sans", "Fontawesome",sans-serif;
    cursor: pointer;
    font-display: swap;
    color: #081a42;
    font-weight: 700;
    text-decoration: none;
    margin-top: 10px;
    display: block;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}
a.tooltip-target:before {
    content: '\f0da';
    font-family: "Font Awesome 5 Free";
    padding-right: 10px;
    color: #267fbc;
}
.open a.tooltip-target {
  content: '\F0D7' !important;
}
/* a.tooltip-target.b3.active:before {
    content: '\f0d7';
} */


.steam-btn img {
    width: 89px;
}
.steam-btn {
    color: #fff;
    width: 397px;
    text-align: left;
    background: linear-gradient(225deg, #1274a7 47%, #081a42 41%);
    margin: auto;
    border-radius: 43px;
    box-shadow: 1px 5px 12px 0px rgba(0,0,0,0.75);
}
.steam-btn span {
    font-size: 34px;
    font-family: Digitalt;
    top: 5px;
    padding-left: 9px;
    text-shadow: 1px 1px 2px #081a42;
    position: relative;
}
.hvr-grow-shadow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow, transform;
  transition-property: box-shadow, transform;
}
.hvr-grow-shadow:hover, .hvr-grow-shadow:focus, .hvr-grow-shadow:active {
      box-shadow: 0 16px 17px -7px rgb(17, 57, 84);

}
@import "https://fonts.googleapis.com/css?family=Rubik+One";
.button::before,
.button::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.module-small #mc_embed_signup .mc-field-group {
    padding-top: 12px;
}
.button {
  display: inline-block;
  padding: 20px 40px;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: 26px;
  transform: translate(-50%, -50%);
  vertical-align: middle;
  font-family: "Rubik One", sans-serif;
  text-decoration: none;
  font-size: 3vw;
  transition: all 0.5s;
  background-color: #3498db;
}
.button::before {
  bottom: -15px;
  height: 15px;
  width: 100%;
  left: 8px;
  transform: skewX(45deg);
  background-color: #196090;
}
.button::after {
  right: -15px;
  height: 100%;
  width: 15px;
  bottom: -8px;
  transform: skewY(45deg);
  background-color: #124364;
}
.button:active {
  margin-left: 10px;
  margin-top: 10px;
}
.button:active::before {
  bottom: -5px;
  height: 5px;
  left: 3px;
}
.button:active::after {
  right: -5px;
  width: 5px;
  bottom: -3px;
}

@font-face {
  font-family: Digitalt;
  font-display: swap;
  src: url(/static/assets/lib/Digitalt.otf);
}
.cta-title {
  font-family: Digitalt;
  font-size: 3px;
  visibility: hidden;
  color: #ffb03d;
  background: linear-gradient(
    to right,
    rgb(255, 181, 63) 0%,
    rgb(255, 255, 255) 15%,
    rgb(255, 255, 255) 29%,
    rgb(255, 255, 255) 75%,
    rgb(255, 255, 255) 77%,
    rgb(255, 177, 61) 100%
  );
}

.ctaImg {
  background: url(/static/assets/images/Yellow-Texture.png);
}

.module-small {
  padding: 95px 0;
}
.cta-subtitle1 {
  font-family: Digitalt;
  font-size: 23px;
  height: 48px;
  color: white;
}
.cta-subtitle {
  font-family: Digitalt;
  font-size: 23px;
  padding-top: 10px;
  line-height: 100%;
}

.overlay:before {
  position: absolute;
  content: " ";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 0;
  background-color: rgba(31, 12, 30, 0.45);
}

.btn {
  padding: 6.5px 32px;
}
.form-control {
  height: 48px;
}
.module-small {
  padding: 0px 0;
  text-align: center;
  widows: 100%;
  height: 213PX;
  overflow: hidden;
  padding-bottom: 0px;
  border-bottom: 9px double #0f0a06;
  border-top: 9px double #0f0a06;
}

.emphasized {
  font-size: 22px;
  display: inline-block;
  color: #3498dd00;
  text-shadow: -2.4px -2.4px 0 #3498dd, -2.4px -0.4px 0 #0a0d0e,
    -1.4px -2.4px 0 #04060a;
}

@media only screen and (max-width: 768px) {
  .col-xs-12 {
        padding-left: 0;
    padding-right: 0;
  }
  .module-small {
        height: 239px;
  }
  .steam-btn{
    width: 314px;
  }
  .steam-btn span{
    font-size: 24px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .emphasized {
    font-size: 13px;
  }
  .cta-subtitle {
    font-size: 14px;
  }
  .cta-title {
    font-size: 14px;
  }
  .btn {
    padding: 8.5px 10px;
  }
}

@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  .form-control {
    height: 39px;
  }
  .btn {
    padding: 8.5px 8px;
  }
  .cta-subtitle1 {
    font-size: 14px;
    height: 39px;
  }
  .cta-subtitle {
    font-size: 12px;
  }
  .cta-title {
    font-size: 17px;
  }
  .emphasized {
    font-size: 12px;
  }
  .callout-btn-box {
    margin-top: -29px !important;
  }
}
.form-group.email label {
  display: none;
}
.form-group {
  display: inline-block;
}


</style>


// WEBPACK FOOTER //
// src/views/Home/CTA3.vue